import { createSlice } from '@reduxjs/toolkit'
import {
  fetchAllUsers,
  fetchOnlineUsers,
  fetchUserDetails
} from 'redux-thunk/thunk/UserManagement/users'

const initialState = {
  userList: null,
  selectedUserDetails: null,
  onlineUserList: [],
  onlineUserCount: 0
}

const userManagementSlice = createSlice({
  name: 'userManagementSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllUsers.fulfilled, (state, action) => {
        return {
          ...state,
          userList: action.payload
        }
      })
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        return {
          ...state,
          selectedUserDetails: action.payload
        }
      })
      .addCase(fetchOnlineUsers.fulfilled, (state, action) => {
        return {
          ...state,
          onlineUserList: action.payload.rows || [],
          onlineUserCount: action.payload.count || 0
        }
      })
  }
})

export default userManagementSlice.reducer
